<template>
  <div>
    <d-form>
      <d-form-row class="form-group">
        <d-col cols="12" md="9">
          <label>Título:</label>
          <d-form-input type="text" v-model="model.name" :state="hasErrorFiled('name')"/>
          <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col cols="12" md="3" class="text-right d-flex align-items-end justify-content-end">
          <label>Jogo Grátis?</label>
          <d-checkbox toggle @change="toggleGameFree()" :checked="model.cat_id === 1" class="ml-3 custom-toggle-sm">
            <span v-if="model.cat_id === 1">Sim</span>
            <span v-else>Não</span>
          </d-checkbox>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="6">
          <label>Tipo de jogo:</label>
          <d-select v-model="model.type_id" :state="hasErrorFiled('type_id')" :disabled="!!model.id">
            <option :value="option.id" v-for="option in types" :key="option.id">{{ option.name }}</option>
          </d-select>
          <d-form-invalid-feedback>Tipo é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col cols="6">
          <label>Dificuldade:</label>
          <d-select v-model="model.level_id" :state="hasErrorFiled('level_id')" @change="chooseLevel">
            <option :value="option.id" v-for="option in levels" :key="option.id">{{ option.name }}</option>
          </d-select>
          <d-form-invalid-feedback>Dificuldade é obrigatório</d-form-invalid-feedback>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="12">
          <label>Imagem destacada:</label>
          <upload-image :model.sync="model" />
        </d-col>
      </d-form-row>
      <component :is="puzzleType" :model.sync="model"/>
    </d-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep, stringfy, getDateTimeUTCISO } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import UploadImage from '_shared/UploadImage.vue';
import PuzzleService from '_services/rest/modules/puzzle';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import Numerix from './PuzzlesTypes/Numerix.vue';
import Letrix from './PuzzlesTypes/Letrix.vue';
import CrossWords from './PuzzlesTypes/CrossWords/index.vue';
import HuntingWords from './PuzzlesTypes/HuntingWords.vue';
import {
  MODEL,
  _LOAD_MODEL_,
  _PUZZLE_CHOOSE_LEVEL_,
} from './PuzzleModel';

export default {
  name: 'puzzle-form',
  mixins: [mixin],
  components: {
    Letrix,
    Numerix,
    CrossWords,
    UploadImage,
    HuntingWords,
    ConfirmationModal,
  },
  computed: {
    types() {
      const { types } = this.$store.state.puzzle;
      if (types.length) {
        return types;
      }
      return [];
    },
    levels() {
      const { levels } = this.$store.state.puzzle;
      if (levels.length) {
        return levels;
      }
      return [];
    },
    status() {
      const { status } = this.$store.state.puzzle;
      if (status.length) {
        return status;
      }
      return [];
    },
    puzzleType() {
      const puzzleTypes = ['HuntingWords', 'CrossWords', 'CrossWords' /* Biblico */, 'Numerix', 'Letrix'];
      if (puzzleTypes[this.model.type_id - 1]) {
        return puzzleTypes[this.model.type_id - 1];
      }
      return 'HuntingWords';
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      title: 'Confirmação',
      callback: null,
      message: 'Tem certeza que deseja continuar?',
      errors: {
        name: { required: false },
        type_id: { required: false },
        level_id: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getTypesList',
      'getLevelsList',
      'getStatusList',
    ]),
    chooseLevel(param) {
      Events.$emit(_PUZZLE_CHOOSE_LEVEL_, param);
    },
    getOptions() {
      if (this.types.length === 0) {
        this.getTypesList();
      }
      if (this.levels.length === 0) {
        this.getLevelsList();
      }
      if (this.status.length === 0) {
        this.getStatusList();
      }
    },
    draft() {
      this.model.status_id = 1;
      this.save();
    },
    publish() {
      this.model.status_id = 2;
      this.model.published_date = new Date();
      this.save();
    },
    save() {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        this.model.published_date = getDateTimeUTCISO(this.model.published_date);
        PuzzleService.save(this.model)
          .then(response => {
            this.$router.push({ name: 'admin-puzzle-edit', params: { puzzleId: response.data.id } });
          })
          .catch(error => {
            this.activeAlert({ message: error.message, theme: 'danger' });
          });
      }
    },
    toggleGameFree() {
      let catId = 1;
      if (this.model.cat_id === 1) {
        catId = null;
      }
      this.model.cat_id = catId;
    },
  },
  mounted() {
    this.getOptions();
    Events.$on(_LOAD_MODEL_, model => {
      this.model = model;
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
